// Module
var code = "<label><input type=\"checkbox\" class=\"filled-in\"/><span></span></label> ";
// Exports
export default code;